"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavRenderComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _Main = _interopRequireDefault(require("./Desktop/Main"));
var _Main2 = _interopRequireDefault(require("./Mobile/Main"));
var _Nav = require("./Nav.style");
var _breakPoints = require("../../constants/breakPoints");
var _menuItems = require("../../constants/menuItems");
var _useScreenSize = require("../hooks/useScreenSize");
var _Spinner = _interopRequireDefault(require("../Spinner"));
const mapMultiColumnSubMenu = nav => {
  if (nav.customRender === _menuItems.CUSTOM_DROPDOWN_MULTI_COLUMN) {
    const toolsAndServicesSubMenu = nav.subMenu.reduce((acc, item) => [...acc, {
      type: item.type,
      text: item.text
    }, ...item.subMenu], []);
    return {
      ...nav,
      subMenu: toolsAndServicesSubMenu
    };
  }
  return nav;
};
const NavRenderComponent = _ref => {
  let {
    logTimeToRender,
    reload,
    isLoading,
    fetchError,
    menuItems,
    ModalComp,
    openChangePasswordModal
  } = _ref;
  const {
    windowWidth
  } = (0, _useScreenSize.useScreenSize)();
  let menu = {
    ...(menuItems || {}),
    primary: (menuItems === null || menuItems === void 0 ? void 0 : menuItems.primary) || []
  };
  const isDesktop = windowWidth > _breakPoints.MAX_HAMBURGER_WIDTH;
  if (windowWidth === 0) return null;
  const Main = isDesktop ? _Main.default : _Main2.default;
  if (!isLoading && logTimeToRender) {
    logTimeToRender();
  }
  if (!isDesktop && menu) {
    const filterPrimaryNav = menu.primary.map(mapMultiColumnSubMenu);

    // @ts-ignore
    menu = {
      ...menu,
      primary: filterPrimaryNav
    };
  }
  return /*#__PURE__*/_react.default.createElement(_Nav.Nav, null, isLoading ? /*#__PURE__*/_react.default.createElement(_Spinner.default, null) : /*#__PURE__*/_react.default.createElement(Main, {
    fetchError: fetchError,
    reload: reload,
    menuItems: menu,
    ModalComp: ModalComp,
    openChangePasswordModal: openChangePasswordModal
  }));
};
exports.NavRenderComponent = NavRenderComponent;
var _default = exports.default = NavRenderComponent;